export const crewManagementText = {
	crewManagementHeader: 'Crew Management',
	warningBanner: {
		showAll: 'Show all',
		crewMemberMissingTitle: 'Crew member info missing.',
		crewMemberMissingInfo:
			'Crew members marked with an icon are missing important information that may affect their eligibility for assignment.',
	},
	noDataLabel: 'No data',
	currentTimezone: 'Your current timezone:',
	notYourTimezone: 'Not your timezone? Update timezone',
};
